import { jobLists } from "character";
import Link from "components/link/Link";
import NoCharacter from "components/no-character/NoCharacter";
import { dungeons } from "data-files/duties";
import { quests } from "data-files/quests";
import { EorzeaDataType, GameData, LinkType, RelicData, View } from "enums";
import manager from "managers/app";
import { ViewRelicInfo } from "managers/types/relic-types";
import { Component } from "react";
import { connect } from "react-redux";
import t from "translations/translator";
import { AppState } from "types/app";
import ContentHeader from "views/page-parts/content/content-header/ContentHeader";
import DetailsSection from "views/page-parts/content/details-section/DetailsSection";
import OverviewTable from "views/page-parts/content/overview-table/OverviewTable";
import { Requirement } from "views/page-parts/content/relic-requirements/types";
import { ViewWeaponAnimaAwokenProps } from "views/relics/weapons/anima/awoken/types";
import "./WeaponAnimaAwoken.css";

const mapStateToProps = (state:AppState) => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
		userInfo: state.userInfo,
		hideCompletedSteps: state.userInfo.options.hideCompletedSteps,
		hideCompletedTasks: state.userInfo.options.hideCompletedTasks,
		showJob: state.userInfo.options.job,
	};
};

class WeaponAnimaAwoken extends Component<ViewWeaponAnimaAwokenProps> {
	private requirements:Requirement[] = [];
	private importantNPCs:GameData.NPC[] = [];
	private relicInfo:ViewRelicInfo = {
		jobs: jobLists.relic[RelicData.Group.WEAPON_ANIMA],
		type: RelicData.Type.WEAPON,
		relic: RelicData.Group.WEAPON_ANIMA,
		part: RelicData.Part.WEAPON_AWOKEN,
		steps: [RelicData.Step.SNOWCLOAK, RelicData.Step.SASTASHA, RelicData.Step.QARN, RelicData.Step.KEEPER, RelicData.Step.WANDERER, RelicData.Step.AMDAPOR_AWOKEN, RelicData.Step.VIGIL, RelicData.Step.SOHM, RelicData.Step.AERY, RelicData.Step.VAULT],
		stepPlaceholders: {
			[RelicData.Step.SNOWCLOAK]: { DUNGEON: GameData.Dungeon.SNOWCLOAK },
			[RelicData.Step.SASTASHA]: { DUNGEON: GameData.Dungeon.SASTASHA_HARD },
			[RelicData.Step.QARN]: { DUNGEON: GameData.Dungeon.QARN_HARD },
			[RelicData.Step.KEEPER]: { DUNGEON: GameData.Dungeon.KEEPER_OF_THE_LAKE },
			[RelicData.Step.WANDERER]: { DUNGEON: GameData.Dungeon.WANDERERS_HARD },
			[RelicData.Step.AMDAPOR_AWOKEN]: { DUNGEON: GameData.Dungeon.AMDAPOR_KEEP_HARD },
			[RelicData.Step.VIGIL]: { DUNGEON: GameData.Dungeon.DUSK_VIGIL },
			[RelicData.Step.SOHM]: { DUNGEON: GameData.Dungeon.SOHM_AL },
			[RelicData.Step.AERY]: { DUNGEON: GameData.Dungeon.AERY },
			[RelicData.Step.VAULT]: { DUNGEON: GameData.Dungeon.VAULT },
		},
		next: {
			part: RelicData.Part.WEAPON_ANIMA,
			view: View.RELIC_WEAPONS_ANIMA_ANIMA,
		},
		previous: {
			part: RelicData.Part.WEAPON_ANIMATED,
			view: View.RELIC_WEAPONS_ANIMA_ANIMATED,
		},
	};

	constructor(props:ViewWeaponAnimaAwokenProps){
		super(props);
		this.requirements = this.getRequirements();
		this.importantNPCs = this.getImportantNPCs();
	}

	render():JSX.Element{
		const character = manager.data.getActiveCharacter();
		if(character === null){ return <NoCharacter />; }

		const completeSteps = manager.content.getCompleteSteps(character.progress, this.relicInfo);

		return (
			<div id="weapon-anima-awoken" className="relic">
				<ContentHeader requirements={this.requirements} importantNPCs={this.importantNPCs} relicInfo={this.relicInfo}>
					<p>{t.t("The %PART% upgrade follows on from %PREVIOUSPART%", { PART: this.relicInfo.part, PREVIOUSPART: this.relicInfo.previous ? this.relicInfo.previous.part : "Unknown"})}</p>
					{t.t("In order to obtain the %PART% you must complete the quest", { PART: RelicData.Part.WEAPON_AWOKEN })}
					<Link type={LinkType.LODESTONE} lodestoneType={EorzeaDataType.BLUEQUEST} text={GameData.Quest.TOUGHENING_UP} lodestoneID={quests[GameData.Quest.TOUGHENING_UP].lodestoneID} />
				</ContentHeader>
				<div id="relic-checklist">
					<OverviewTable character={character} completeSteps={completeSteps} relicInfo={this.relicInfo} />
				</div>
				<div id="relic-details">
					<h1>{t.t("Details")}</h1>
					{this.props.hideCompletedSteps && completeSteps.allComplete ? t.t("All Steps Complete") : null }
					<DetailsSection title={RelicData.Step.SNOWCLOAK} placeholders={this.relicInfo.stepPlaceholders[RelicData.Step.SNOWCLOAK]} id={RelicData.Step.SNOWCLOAK} stepComplete={completeSteps[RelicData.Step.SNOWCLOAK]}><p>{t.t("Complete")}<Link type={LinkType.LODESTONE} lodestoneType={dungeons[GameData.Dungeon.SNOWCLOAK].type} text={dungeons[GameData.Dungeon.SNOWCLOAK].name} lodestoneID={dungeons[GameData.Dungeon.SNOWCLOAK].lodestoneID} /></p></DetailsSection>
					<DetailsSection title={RelicData.Step.SASTASHA} placeholders={this.relicInfo.stepPlaceholders[RelicData.Step.SASTASHA]} id={RelicData.Step.SASTASHA} stepComplete={completeSteps[RelicData.Step.SASTASHA]}><p>{t.t("Complete")}<Link type={LinkType.LODESTONE} lodestoneType={dungeons[GameData.Dungeon.SASTASHA_HARD].type} text={dungeons[GameData.Dungeon.SASTASHA_HARD].name} lodestoneID={dungeons[GameData.Dungeon.SASTASHA_HARD].lodestoneID} /></p></DetailsSection>
					<DetailsSection title={RelicData.Step.QARN} placeholders={this.relicInfo.stepPlaceholders[RelicData.Step.QARN]} id={RelicData.Step.QARN} stepComplete={completeSteps[RelicData.Step.QARN]}><p>{t.t("Complete")}<Link type={LinkType.LODESTONE} lodestoneType={dungeons[GameData.Dungeon.QARN_HARD].type} text={dungeons[GameData.Dungeon.QARN_HARD].name} lodestoneID={dungeons[GameData.Dungeon.QARN_HARD].lodestoneID} /></p></DetailsSection>
					<DetailsSection title={RelicData.Step.KEEPER} placeholders={this.relicInfo.stepPlaceholders[RelicData.Step.KEEPER]} id={RelicData.Step.KEEPER} stepComplete={completeSteps[RelicData.Step.KEEPER]}><p>{t.t("Complete")}<Link type={LinkType.LODESTONE} lodestoneType={dungeons[GameData.Dungeon.KEEPER_OF_THE_LAKE].type} text={dungeons[GameData.Dungeon.KEEPER_OF_THE_LAKE].name} lodestoneID={dungeons[GameData.Dungeon.KEEPER_OF_THE_LAKE].lodestoneID} /></p></DetailsSection>
					<DetailsSection title={RelicData.Step.WANDERER} placeholders={this.relicInfo.stepPlaceholders[RelicData.Step.WANDERER]} id={RelicData.Step.WANDERER} stepComplete={completeSteps[RelicData.Step.WANDERER]}><p>{t.t("Complete")}<Link type={LinkType.LODESTONE} lodestoneType={dungeons[GameData.Dungeon.WANDERERS_HARD].type} text={dungeons[GameData.Dungeon.WANDERERS_HARD].name} lodestoneID={dungeons[GameData.Dungeon.WANDERERS_HARD].lodestoneID} /></p></DetailsSection>
					<DetailsSection title={RelicData.Step.VIGIL} placeholders={this.relicInfo.stepPlaceholders[RelicData.Step.VIGIL]} id={RelicData.Step.VIGIL} stepComplete={completeSteps[RelicData.Step.VIGIL]}><p>{t.t("Complete")}<Link type={LinkType.LODESTONE} lodestoneType={dungeons[GameData.Dungeon.DUSK_VIGIL].type} text={dungeons[GameData.Dungeon.DUSK_VIGIL].name} lodestoneID={dungeons[GameData.Dungeon.DUSK_VIGIL].lodestoneID} /></p></DetailsSection>
					<DetailsSection title={RelicData.Step.SOHM} placeholders={this.relicInfo.stepPlaceholders[RelicData.Step.SOHM]} id={RelicData.Step.SOHM} stepComplete={completeSteps[RelicData.Step.SOHM]}><p>{t.t("Complete")}<Link type={LinkType.LODESTONE} lodestoneType={dungeons[GameData.Dungeon.SOHM_AL].type} text={dungeons[GameData.Dungeon.SOHM_AL].name} lodestoneID={dungeons[GameData.Dungeon.SOHM_AL].lodestoneID} /></p></DetailsSection>
					<DetailsSection title={RelicData.Step.AERY} placeholders={this.relicInfo.stepPlaceholders[RelicData.Step.AERY]} id={RelicData.Step.AERY} stepComplete={completeSteps[RelicData.Step.AERY]}><p>{t.t("Complete")}<Link type={LinkType.LODESTONE} lodestoneType={dungeons[GameData.Dungeon.AERY].type} text={dungeons[GameData.Dungeon.AERY].name} lodestoneID={dungeons[GameData.Dungeon.AERY].lodestoneID} /></p></DetailsSection>
					<DetailsSection title={RelicData.Step.VAULT} placeholders={this.relicInfo.stepPlaceholders[RelicData.Step.VAULT]} id={RelicData.Step.VAULT} stepComplete={completeSteps[RelicData.Step.VAULT]}><p>{t.t("Complete")}<Link type={LinkType.LODESTONE} lodestoneType={dungeons[GameData.Dungeon.VAULT].type} text={dungeons[GameData.Dungeon.VAULT].name} lodestoneID={dungeons[GameData.Dungeon.VAULT].lodestoneID} /></p></DetailsSection>
				</div>
			</div>
		);
	}

	componentDidMount(){
		manager.view.changeComplete();
	}

	private getRequirements():Requirement[]{
		if(!this.relicInfo || this.relicInfo.previous === null){ return []; }
		return [
			{ type: "previous part", part: this.relicInfo.previous.part, partView: this.relicInfo.previous.view },
		];
	}

	private getImportantNPCs():GameData.NPC[]{
		return [GameData.NPC.ARDASHIR];
	}
}
export default connect(mapStateToProps)(WeaponAnimaAwoken);
